export default __webpack_public_path__ + "static/coperta-teaser-marci-proprii-9be33c11a115cc454c71f918d8efeb09.jpg";